import { editionListSchema, editionSummarySchema, eventRulesSchema } from '@koderek/shared';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../api/client';
import { useMe } from '../auth/session';

/** Klucze zależą od zalogowanego konta – oznaczenia „Masz zapisy” są per konto (US-104 AC-3). */
export function useEditions() {
  const me = useMe();
  return useQuery({
    queryKey: ['editions', me.data?.id ?? null],
    queryFn: () => apiGet('/editions', editionListSchema),
    enabled: !me.isPending,
  });
}

export function useEdition(slug: string) {
  const me = useMe();
  return useQuery({
    queryKey: ['edition', slug, me.data?.id ?? null],
    queryFn: () => apiGet(`/editions/${encodeURIComponent(slug)}`, editionSummarySchema),
    enabled: !me.isPending,
  });
}

export function usePastEditions() {
  return useQuery({ queryKey: ['editions', 'past'], queryFn: () => apiGet('/account/editions/past', editionListSchema) });
}

/** Ogólne ustawienia wydarzenia (PRD §10 pkt 63) – czy edycje dnia w różnych miastach się wykluczają. */
export function useEventRules() {
  return useQuery({
    queryKey: ['settings', 'event-rules'],
    queryFn: () => apiGet('/settings/event-rules', eventRulesSchema),
    staleTime: 5 * 60_000,
  });
}
